/*
 * Content
 *
 * Content wrapper for Header and content
 */

import "./styles.scss";

import React, { Component } from "react";

/* eslint-disable react/prefer-stateless-function */
export default class Content extends Component<any, any> {
	render() {
		return (
			<div className="Content">
				{this.props.children}
			</div>
		);
	}
}
